import { ROUTE_ACCOUNT } from '@/constants/routes';
import { RouteObject } from 'react-router-dom';
import Page from './account.page';
import setTitleFromLoader from '@/utils/routing/set-title';

export const routeAccount: RouteObject = {
  path: ROUTE_ACCOUNT,
  Component: Page,
  loader: setTitleFromLoader('Account'),
};
